// services/DepartmentService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// LIST (paginated)
export function getDepartments(params = {}) {
    return api.get(ENDPOINTS.DEPARTMENTS.BASE, { params });
}

// GET ONE
export function getDepartmentById(id) {
    return api.get(ENDPOINTS.DEPARTMENTS.BY_ID(id));
}

// CREATE
export function createDepartment(payload) {
    return api.post(ENDPOINTS.DEPARTMENTS.BASE, payload);
}

// UPDATE
export function updateDepartment(id, payload) {
    return api.patch(ENDPOINTS.DEPARTMENTS.BY_ID(id), payload);
}

// DELETE (soft delete)
export function deleteDepartment(id) {
    return api.delete(ENDPOINTS.DEPARTMENTS.BY_ID(id));
}

// RESTORE
export function restoreDepartment(id) {
    return api.post(`${ENDPOINTS.DEPARTMENTS.BY_ID(id)}/restore`);
}
